import { render } from "./iconAddBook.vue?vue&type=template&id=23da1e97"
import script from "./iconAddBook.vue?vue&type=script&lang=js"
export * from "./iconAddBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__